import { ReactElement } from 'react'

import { ListFrotista } from '../../domain/usecases/ListFrotista'
import UserRepository from '../../infra/repositories/UserRepository'
import CnpjsVinculados from '../../pages/CnpjsVinculados'

export const CnpjsVinculadosFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const listFrotista = new ListFrotista(userRepository)

  return <CnpjsVinculados listFrotista={listFrotista} />
}
